import { render } from "./TestScenarioTable.vue?vue&type=template&id=5a215a85"
import script from "./TestScenarioTable.vue?vue&type=script&lang=js"
export * from "./TestScenarioTable.vue?vue&type=script&lang=js"

import "./TestScenarioTable.vue?vue&type=style&index=0&id=5a215a85&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__